<template>
  <el-col>
    <el-card class="data" v-loading="loading_track">
      <div class="data-title" slot="header">
        <i class="fas fa-chart-bar"></i>
        <span>TRACK DATA</span>
      </div>
      <GChart
        type="ColumnChart"
        :data="track_chart"
        :options="ColumnChart"
        v-if="track_chart.length > 1"
      />
      <div v-else class="no-data"><span>No Data</span></div>
      <div class="card-footer">
        <div class="border"></div>
      </div>
    </el-card>
  </el-col>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { GChart } from 'vue-google-charts'

export default {
  components: {
    GChart
  },

  computed: {
    ...mapState('labelDashboard', ['ColumnChart', 'loading_track']),
    ...mapGetters('labelDashboard', ['track_chart'])
  },

  data() {
    return {
      selectedCommand: 'Date range',
      activeName: 'first'
    }
  },

  methods: {
    ...mapActions('labelDashboard', ['readTrack']),
    handleCommand(command) {
      this.selectedCommand = command
    }
  },

  created() {
    this.readTrack()
  }
}
</script>

